// POST /api/manifest/by-shipment (Django) — dada una lista de guías, en qué manifiesto
// está cada una. Reemplaza consultar `logistics.ManifestDetailVW` desde el front.
//
// Se usa para explicar por qué una guía de una carga masiva NO aparece en la lista de
// guías despachables: casi siempre porque ya está manifestada. Sin esto el operador solo
// veía un conteo ("3 guías no están disponibles") sin saber cuáles ni por qué.
//
// Envelope Django estándar: HTTP siempre 200, el error se lee de `error`/`code`.

export interface ManifestByShipmentRequest {
  /** Guías a consultar. Máximo 5000 por request (el servidor rechaza más). */
  shipment_numbers: string[]
  /** Filtros GLOBALES de la consulta, no por guía, y aplican al MANIFIESTO. */
  bu_code_source?: string | null
  bu_code_destination?: string | null
  manifest_type_id?: number | null
}

export interface ManifestSummaryDto {
  manifest_id: string
  code: string
  manifest_type_id: number
  status: { id: number; name: string }
  origin_store: { code: string; bu_type_id: number }
  destination_store: { code: string; bu_type_id: number }
  creation_date: string
  /** null mientras el manifiesto siga abierto. */
  closed_date: string | null
  reception_manifest: { manifest_id: string; code: string } | null
}

export interface ManifestByShipmentDto {
  /** Viene EXACTAMENTE como se envió, así que sirve de clave contra la lista de entrada. */
  shipment_number: string
  /**
   * Del más reciente al más antiguo → `manifests[0]` es el vigente. Una guía puede
   * estar en varios (despacho y recepción).
   *
   * Vacío NO prueba que la guía no esté manifestada: la búsqueda llega a la guía por
   * `ShipmentDetailID` y el backend midió un 24% de piezas escaneadas sin ese vínculo.
   * Es el mismo punto ciego que la vista que se usaba antes. Por eso el copy dice "No
   * se encontró en ningún manifiesto" y no "No está en ningún manifiesto".
   *
   * Tampoco distingue "guía inexistente" de "guía sin manifiesto": las dos dan vacío.
   *
   * Y depende de PERMISOS: solo se consideran los manifiestos que el usuario puede leer
   * (los suyos o los de sus account sites). Una guía en un manifiesto de otra sucursal
   * vuelve vacía.
   */
  manifests: ManifestSummaryDto[]
}

/** Tope duro del servidor. Se parte la consulta en tandas de este tamaño. */
export const MANIFEST_BY_SHIPMENT_MAX = 5000
